import { useState, useEffect } from 'react';
const useKeyboardNav = ({ onSubmit, onExit, onFocus, length, disabled, initialIndex = 0, submitOnSpaceClick = false, }, dependencies = []) => {
    const [selectedItem, setSelectedItem] = useState(initialIndex);
    useEffect(() => {
        if (onFocus && !disabled)
            onFocus(selectedItem);
    }, [selectedItem, disabled, onFocus]);
    useEffect(() => {
        if (disabled)
            return;
        const handleKeyboardNavigation = (event) => {
            const linksLength = length;
            const handleArrowDown = () => {
                if (selectedItem === linksLength - 1) {
                    setSelectedItem(0);
                }
                else {
                    setSelectedItem(selectedItem + 1);
                }
            };
            const handleArrowUp = () => {
                return selectedItem <= 0
                    ? setSelectedItem(linksLength - 1)
                    : setSelectedItem(selectedItem - 1);
            };
            switch (event.key) {
                case 'ArrowDown':
                    event.preventDefault();
                    handleArrowDown();
                    break;
                case 'ArrowUp':
                    event.preventDefault();
                    handleArrowUp();
                    break;
                case ' ': // Space
                    if (submitOnSpaceClick) {
                        if (selectedItem > -1) {
                            event.preventDefault();
                            if (onSubmit)
                                onSubmit(event, selectedItem);
                        }
                    }
                    break;
                case 'Enter':
                    if (selectedItem > -1) {
                        event.preventDefault();
                        if (onSubmit)
                            onSubmit(event, selectedItem);
                    }
                    break;
                case 'Tab':
                    if (onExit)
                        onExit();
                    break;
                case 'Escape':
                    setSelectedItem(0);
                    if (onExit)
                        onExit();
                    break;
                default:
            }
        };
        const handleDocumentClick = () => onExit && onExit();
        document.addEventListener('keydown', handleKeyboardNavigation);
        document.addEventListener('click', handleDocumentClick);
        // eslint-disable-next-line consistent-return
        return () => {
            document.removeEventListener('keydown', handleKeyboardNavigation);
            document.removeEventListener('click', handleDocumentClick);
        };
    }, [...dependencies, selectedItem, length, disabled]);
    return [selectedItem, setSelectedItem];
};
export default useKeyboardNav;
//# sourceMappingURL=useKeyboardNav.js.map